import { render } from "./GenericButton.vue?vue&type=template&id=20727388&scoped=true"
import script from "./GenericButton.vue?vue&type=script&lang=js"
export * from "./GenericButton.vue?vue&type=script&lang=js"

import "./GenericButton.vue?vue&type=style&index=0&id=20727388&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20727388"]])

export default __exports__